import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export function AdminDefaultRedirect() {
  const { isSuperAdmin } = useAuth();
  return <Navigate to={isSuperAdmin ? '/admin/dashboard' : '/admin/clients'} replace />;
}
